import './css/map.css';
import React from 'react';
import 'leaflet/dist/leaflet.css';
import MapWithTable from './MapWithTable';

function MapWithSidePanel() {
  return (
    <div>
      <MapWithTable />
    </div>
  );
}

export default MapWithSidePanel;
